export const AccountIsAChapel = (vaccount) => {
    return vaccount?.locationId !== null;
}

export const AccountNotAChapel = (vaccount) => {
    return vaccount?.locationId === null;
}